export default __webpack_public_path__ + "static/image-26-3f671cd75bb3fbda84a7b1f69e55a50c.jpg";